import { Box, Container, Typography, Breakpoint } from '@mui/material';
import { NeutralColors } from '@neumind/shared/branding';
import { marketing } from '../../styles/theme';

interface SectionProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  variant?: 'default' | 'gradient' | 'dark' | 'muted';
  py?: number;
  centered?: boolean;
  id?: string;
  maxWidth?: Breakpoint | false;
}

export function Section({
  children,
  title,
  subtitle,
  variant = 'default',
  py = 10,
  centered = false,
  id,
  maxWidth = 'lg',
}: SectionProps) {
  const bgStyles = {
    default: { bgcolor: 'background.default' },
    muted: { bgcolor: 'grey.50' },
    gradient: {
      background:
        'linear-gradient(135deg, rgba(77, 101, 255, 0.05) 0%, rgba(14, 165, 223, 0.05) 100%)',
    },
    dark: { bgcolor: NeutralColors[900], backgroundImage: marketing.gradients.dark, color: 'white' },
  };

  return (
    <Box component="section" id={id} sx={{ py, ...bgStyles[variant] }}>
      <Container maxWidth={maxWidth}>
        {(title || subtitle) && (
          <Box sx={{ textAlign: centered ? 'center' : 'left', mb: 8 }}>
            {title && (
              <Typography
                variant="h2"
                sx={{
                  mb: 2,
                  color: variant === 'dark' ? 'white' : 'text.primary',
                }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                variant="body1"
                sx={{
                  color: variant === 'dark' ? 'grey.300' : 'text.secondary',
                  maxWidth: centered ? 700 : 'none',
                  mx: centered ? 'auto' : 0,
                  fontSize: '1.25rem',
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        )}
        {children}
      </Container>
    </Box>
  );
}
